import React from 'react'
import Apc from './Apc'
import Portfolio from './Portfolio'
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Link
  } from "react-router-dom";

export default function Inro() {
    return (<>
        <div style={{display:"flex"}}>
            <div  style={{display:'flex',justifyContent:'center',flexWrap:"wrap",marginLeft:'10vw',marginTop:'4vw'}}>
            <img className="imga float my-4 mx-4" src="https://storage.googleapis.com/kaggle-competitions/kaggle/3649/media/cifar-10.png" width= "30%"
  height="auto" ></img>
  <div style={{display:'flex',flexDirection:"column",marginRight:"9vw" , marginTop:'8vw', marginLeft:'8vw',flexWrap:"wrap"}}>
            
            <div ><h1><b>Welcome To Object Detector</b></h1> </div>
          

            
            <div ><h1><b>We can Detect</b></h1></div>
            <Apc/>
            <br/>
            <br/>
            <br/>
            <br/>
            <div style={{display:"flex" ,justifyContent:"space-evenly"}}>
                <Link to="/upload">

                <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-box-arrow-in-down" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z"/>
  <path fill-rule="evenodd" d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
</svg>

                </Link>
            

<Link to="/upload">
<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-camera" viewBox="0 0 16 16">
  <path d="M15 12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.172a3 3 0 0 0 2.12-.879l.83-.828A1 1 0 0 1 6.827 3h2.344a1 1 0 0 1 .707.293l.828.828A3 3 0 0 0 12.828 5H14a1 1 0 0 1 1 1v6zM2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2z"/>
  <path d="M8 11a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM3 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z"/>
</svg>
</Link>



                
</div>
            
            </div>
           
            
         
            
            </div>

        </div>
        
        
        <span className="container  mx-5 ">
            
        </span>
        
        </>
    )
}
